import config from "console_config";
import logger from "Libs/logger";
import { request } from "Libs/platform";
import { createAppAsyncThunk } from "Store/createAppAsyncThunk";

import { projectCreationActions } from "../projectCreation.reducer";

import type { GithubRepositories } from "../projectCreation.types";

const githubAppEndpoint = `${config.URL_API_PROXY}/gh`;

export type FetchGithubRepositoriesProps = {
  organizationId: string;
  installationId: string;
};

/**
 * Fetches GitHub repositories for a selected GitHub organization/installation.
 *
 * This thunk fetches repositories available to a specific GitHub App installation
 * and stores them in Redux state.
 */
export const fetchGithubRepositories = createAppAsyncThunk(
  "onboarding/fetchGithubRepositories",
  async (
    { organizationId, installationId }: FetchGithubRepositoriesProps,
    { dispatch, rejectWithValue }
  ) => {
    dispatch(
      projectCreationActions.setGitProviderLoading({
        organizationId,
        isLoading: true
      })
    );

    try {
      const response = (await request(
        `${githubAppEndpoint}/${organizationId}/orgs/${installationId}/repos`
      )) as GithubRepositories;

      dispatch(
        projectCreationActions.setGithubRepositories({
          organizationId,
          repositories: response.repositories
        })
      );

      dispatch(
        projectCreationActions.setGitProviderLoading({
          organizationId,
          isLoading: false
        })
      );

      return {
        repositories: response.repositories,
        totalCount: response.total_count
      };
    } catch (err: unknown) {
      const error = err instanceof Error ? err.message : "An error occurred";

      logger(err, {
        action: "fetchGithubRepositories",
        organizationId,
        installationId
      });

      dispatch(
        projectCreationActions.setGitProviderError({
          organizationId,
          error
        })
      );

      return rejectWithValue({ error });
    }
  }
);
